<template>
  <div v-if="isVisible" class="bg-accent py-4 -mt-px">
    <div class="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="w-full flex items-center border-b-2 border-green-300 pb-0">
        <input type="text" v-model="searchQuery" placeholder="Find a book or author" @keydown.enter="handleSearch"
          @keydown.escape="closeSearch" autofocus
          class="flex-1 bg-transparent text-white placeholder-white/70 border-none outline-none text-base font-body mr-4 text-left" />
        <div class="flex items-center">
          <button @click="closeSearch" class="p-2 text-white hover:text-green-200 transition-colors flex-shrink-0"
            aria-label="Close search">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <button @click="handleSearch"
            class="p-2 bg-white text-accent hover:bg-creme-100 transition-colors flex-shrink-0" aria-label="Search">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { publicService } from '../services/public'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close', 'search'])

const isVisible = ref(props.visible)
const searchQuery = ref('')

watch(() => props.visible, (newVal) => {
  isVisible.value = newVal
  if (newVal) {
    searchQuery.value = ''
  }
})

const handleSearch = () => {
  if (searchQuery.value.trim()) {
    // Record search analytics only when user explicitly searches
    publicService.recordSearch(searchQuery.value.trim(), '/books')
    emit('search', searchQuery.value.trim())
    closeSearch()
  }
}

const closeSearch = () => {
  isVisible.value = false
  searchQuery.value = ''
  emit('close')
}
</script>
